<template>
  <div class="assessment-mode-page">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AssessmentMode',
}
</script>

<style scoped>
.assessment-mode-page {
  position: relative;
  width: 100vw;
  min-height: 100%;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  overflow-x: hidden;
  z-index: 2;
}
</style>
